import { render, staticRenderFns } from "./ArticleSharePage.vue?vue&type=template&id=0d49f1cc&scoped=true&"
import script from "./ArticleSharePage.vue?vue&type=script&lang=js&"
export * from "./ArticleSharePage.vue?vue&type=script&lang=js&"
import style0 from "./ArticleSharePage.vue?vue&type=style&index=0&id=0d49f1cc&scoped=true&lang=css&"
import style1 from "./ArticleSharePage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d49f1cc",
  null
  
)

export default component.exports